import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PropsType from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";

const locale = "en-US";

const CustomTextFieldForeDate = (props) => {
  const { inputProps, valueMoment, onBlur, shouldDisableDate } = props;
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(inputProps.value);
  }, [inputProps.value]);

  return (
    <TextField
      {...props}
      value={value}
      inputProps={{ ...props.inputProps, value: value }}
      onBlur={(e) => {
        onBlur(e);
        console.log("valuEmOMENT", valueMoment);
        if (
          !valueMoment ||
          (valueMoment &&
            shouldDisableDate &&
            shouldDisableDate(valueMoment)) ||
          (!!valueMoment && !valueMoment.isValid())
        ) {
          setValue("");
        }
      }}
    />
  );
};

const DatePickerCustom = (props) => {
  const {
    value,
    onChange,
    size,
    title,
    placeholder,
    className,
    inputFormat,
    style,
    error,
    required,
    onBlur,
    ref,
    shouldDisableDate,
    ...rest
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} locale={locale}>
      <Box className={className}>
        <DatePicker
          value={value || null}
          onChange={(newValue) => {
            onChange(newValue);
          }}
          className="w-full"
          label={title}
          inputFormat={inputFormat || "DD/MM/YYYY"}
          shouldDisableDate={shouldDisableDate}
          {...rest}
          renderInput={(params) => {
            // console.log("params of date", params);
            return (
              <CustomTextFieldForeDate
                {...params}
                shouldDisableDate={shouldDisableDate}
                onBlur={onBlur}
                ref={ref}
                size={size}
                error={error}
                required={required}
                helperText={error && error.message}
                valueMoment={value}
                inputProps={{
                  ...params.inputProps,
                  placeholder: placeholder ?? "DD/MM/YYYY",
                }}
              />
            );
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

DatePickerCustom.propTypes = {
  className: PropsType.string,
  disabled: PropsType.bool,
  disableFuture: PropsType.bool,
  acceptRegex: PropsType.any,
  closeOnSelect: PropsType.bool,
  disableHighlightToday: PropsType.bool,
  disableMaskedInput: PropsType.bool,
  disableOpenPicker: PropsType.bool,
  disablePast: PropsType.bool,
  inputFormat: PropsType.string,
  shouldDisableDate: PropsType.any,
  shouldDisableMonth: PropsType.any,
  shouldDisableYear: PropsType.any,
  title: PropsType.string,
  placeholder: PropsType.string,
  value: PropsType.any,
  onChange: PropsType.any,
  error: PropsType.any,
};

export default DatePickerCustom;
